function getTimestamp() {
  return new Date().toISOString();
}

function buildPrefix(level: 'error' | 'warn' | 'info' | 'log') {
  return `[${level.toUpperCase()} ${getTimestamp()}]`;
}

export function logError(message: string, ...args: unknown[]) {
  console.error(buildPrefix('error'), message, ...args);
}

export function logWarn(message: string, ...args: unknown[]) {
  console.warn(buildPrefix('warn'), message, ...args);
}

export function logInfo(message: string, ...args: unknown[]) {
  console.info(buildPrefix('info'), message, ...args);
}

export function log(message: string, ...args: unknown[]) {
  console.log(buildPrefix('log'), message, ...args);
}
